import React from 'react';
import { Asset } from 'types/asset';
import { getValueSafely } from 'utils/utils';

export default function AccuracyRangeSpan({ asset }: { asset: Asset }) {
  const accuracyRangeString = getValueSafely(
    asset.location?.uncertainty?.toFixed(1),
    ' metres',
  );

  return <span>{accuracyRangeString}</span>;
}
